import { Text } from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';

import { useBodyTypesFilter } from '@/hooks/filters/body-types-filter.hook';
import { useColorsFilter } from '@/hooks/filters/colors-filter.hook';
import { useDoorsFilter } from '@/hooks/filters/doors-filter.hook';
import { ColourTypeItem } from '@/old-shared/components/filters/body-filter/colour-type-item/colour-type-item';

import { FilterBlocks } from '../../filters/filter-blocks/filter-blocks';
import { MobileFilter } from '../../filters/mobile-filter/mobile-filter';

import styles from './body-filter.module.scss';
import { BodyTypeItem } from './components/body-type-item/body-type-item';

export const BodyFilters: React.FC<{
  fromBanner?: boolean;
  pageType?: string;
  handleVisibleChange?: (isVisible: boolean) => void;
  isVisible?: boolean;
  isDisplayBodyType?: boolean;
}> = ({
  fromBanner,
  handleVisibleChange,
  isVisible,
  pageType,
  isDisplayBodyType,
}) => {
  const { colorFilters, toggleColorFilter, setColorFilters } =
    useColorsFilter();
  const { doorsFilter, toggleDoorsFilter, setDoorsFilter } = useDoorsFilter();
  const { bodyTypesFilter, toggleBodyTypeFilter, setBodyTypesFilter } =
    useBodyTypesFilter();

  const [bodyTypes, setBodyTypes] = useState(bodyTypesFilter);
  const [bodyColors, setBodyColors] = useState(colorFilters);
  const [bodyDoors, setBodyDoors] = useState(doorsFilter);

  useEffect(() => {
    if (isVisible) {
      setBodyTypes(bodyTypesFilter);
      setBodyColors(colorFilters);
      setBodyDoors(doorsFilter);
    }
  }, [isVisible]);

  const bodyColorFilters = colorFilters;
  const bodyTypesFilters = bodyTypesFilter;
  const bodyDoorsFilters = doorsFilter;

  const onClose = () => {
    setBodyTypesFilter(bodyTypes);
    setColorFilters(bodyColors);
    setDoorsFilter(bodyDoors);
  };

  return (
    <MobileFilter
      title="Body"
      handleVisibleChange={handleVisibleChange}
      isVisible={isVisible}
      onClose={onClose}
    >
      <div className={styles.body}>
        {isDisplayBodyType === false ? null : (
          <div className={styles.bodySection}>
            <Text className={styles.bodySectionName}>Body Types</Text>
            <div className={styles.bodyContent}>
              {bodyTypesFilters.map((bodyType) => (
                <BodyTypeItem
                  key={bodyType.id}
                  pageType={pageType}
                  bodyType={bodyType}
                  selectFilter={toggleBodyTypeFilter}
                />
              ))}
            </div>
          </div>
        )}
        <div className={styles.bodySection}>
          <Text className={styles.bodySectionName}>Colour</Text>
          <div className={styles.bodyContent}>
            {bodyColorFilters.map((colourType) => (
              <ColourTypeItem
                key={colourType.id}
                colourType={colourType}
                selectFilter={toggleColorFilter}
              />
            ))}
          </div>
        </div>
        {!fromBanner && (
          <div className={styles.bodySection}>
            <FilterBlocks
              label="Doors"
              filters={bodyDoorsFilters}
              onSelect={toggleDoorsFilter}
            />
          </div>
        )}
      </div>
    </MobileFilter>
  );
};
